"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createIsPhoneRegisteredModel = createIsPhoneRegisteredModel;
exports.defaultConfig = void 0;
exports.fetchIsPhoneRegistered = fetchIsPhoneRegistered;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable */

//tslint:disable

const defaultConfig = exports.defaultConfig = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'users',
  pathApi: '/v1/is-phone-registered/',
  hostType: 'api'
};
function createIsPhoneRegisteredModel(parameters) {
  return _objectSpread(_objectSpread({}, defaultConfig), {}, {
    parameters
  });
}
async function fetchIsPhoneRegistered(_ref) {
  let {
    httpApi,
    parameters,
    config,
    mappers
  } = _ref;
  const {
    response,
    statusCode
  } = await httpApi.fetch(createIsPhoneRegisteredModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response);
    }
    if (statusCode === 400) {
      return mappers[400](response);
    }
  }
  return {
    response,
    statusCode
  };
}